import { Controller } from "@hotwired/stimulus";
import { CsrfToken } from "../shared/csrf_token";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--form-submit"
export default class extends Controller {
  static values = {
    controller: String,
    action: String,
    target: String,
  };

  connect() {
    TurboStreamHeaders(this);
    CsrfToken(this);
  }

  submit(e) {
    e.preventDefault();

    const form = this.element;
    const url = form.action;
    const formData = new FormData(form);

    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        ...this.csrfToken(),
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);

        const controller = this.controllerValue;
        const action = this.actionValue;
        const target = this.targetValue;
        if (controller && action && target) {
          setTimeout(() => {
            this._invokeAction(controller, action, target);
          }, 300);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }

  _invokeAction(controller, action, target) {
    const targetController =
      this.application.getControllerForElementAndIdentifier(
        document.querySelector(
          `[data-resumin--form-submit-target='${target}']`
        ),
        controller
      );
    if (targetController && typeof targetController[action] === "function") {
      targetController[action]();
    }
  }
}
